const tabHistory = {
  state: {
    history: {}
  },

  mutations: {
    SET_HISTORY: (state, history) => {
      state.history = history
    }
  },
  actions: {
		//记录历史路径
		NodeHistory({ commit }, history) {
			commit('SET_HISTORY', history)
		}
  }
}

export default tabHistory



// WEBPACK FOOTER //
// ./src/store/modules/history.js